import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Form from 'components/form';
import times from 'lodash/times';
import React from 'react';
import { useForm } from './Form';
const { FormItem } = Form;

const RatingField = React.forwardRef(
  ({ id, required, value, helpText, hasError, onChange }, ref) => {
    const theme = useTheme();
    const color = theme.palette.primary.main;
    return (
      <Box mt={1} maxWidth={350} mx="auto">
        <Stack direction="row" spacing={2} justifyContent="center" px={1}>
          {times(5).map((i) => {
            if (i < value) {
              return (
                <StarIcon
                  key={i}
                  onClick={() => onChange(i + 1)}
                  sx={{
                    cursor: 'pointer',
                    color,
                    fontSize: 50,
                  }}
                />
              );
            }
            return (
              <StarOutlineIcon
                key={i}
                sx={{
                  fontSize: 50,
                  cursor: 'pointer',
                  color,
                }}
                onClick={() => onChange(i + 1)}
              />
            );
          })}
        </Stack>
        {hasError && (
          <FormHelperText error sx={{ m: 0, mt: 1 }}>
            {helpText}
          </FormHelperText>
        )}
      </Box>
    );
  },
);

const Rating = ({ id, required }) => {
  const { getFieldDecorator } = useForm();

  return (
    <FormItem>
      {getFieldDecorator(id, {
        rules: [{ required, message: 'Please select a rating' }],
      })(<RatingField />)}
    </FormItem>
  );
};

export default Rating;
